import { TFunction } from 'next-i18next'

export const guidePostClassThanks = (t: TFunction): { content: string } => ({
  content: t('postClassThanks.content', { ns: 'fixtureMessage' })
    .replace(/<apply>/g, '<a href="https://bit.ly/Call4IGLounge" target="_blank">')
    .replace(/<\/apply>/g, '</a>'),
})
